/* eslint-disable max-len */

import React from 'react'
import { ShimmerBadge, ShimmerTable } from 'react-shimmer-effects'

export default function OrderListingSkeleton({type}) {
    return (
        <div>
            <div className="flex md:justify-between justify-start md:items-center items-start md:flex-row flex-col lg:mx-12 ml-0 mt-2">
                <ul className="nav nav-pills flex flex-row list-none pl-0 mb-4 mt-5 md:ml-12 ml-3" id="pills-tab" role="tablist">
                    <li className="nav-item mr-[70px]" role="presentation">
                        <a href="#pills-home" className="nav-link block active  myOrders relative text-xs21 font-semibold text-[#555259]" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true"><ShimmerBadge/></a>
                    </li>
                    <li className="nav-item" role="presentation">
                        <a href="#pills-profile" className="nav-link block myOrders relative text-xs21 font-semibold text-[#555259] draft-order1" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false"><ShimmerBadge/></a>
                    </li>
                </ul>
                <div className="filter">
                    <div className="flex mb-3 mt-3 mx-2 md:justify-end justify-strat items-center w-full">
                        <button type="button" className="bg-[#F5F5FA] font-bold text-xs h-9 text-[#555259] border-2 border-[#E9EDF4] py-1 px-4 rounded-[9px]"style={{border:'2px solid #E9EDF4'}} data-bs-toggle="modal" data-bs-target="#filtermodal">
                            <ShimmerBadge/>
                        </button>
                        <button type="button" id="exportDropdown" data-bs-toggle="dropdown" aria-expanded="false" className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] w-[79px] border border-[#555259] ml-2 rounded-lg">
                            <ShimmerBadge/>
                        </button>
                        <div className="ml-3 relative cursor-pointer sm:mt-0 mt-1">
                            <input type="text" className="w-[180px] h-9 border-2 border-[#E9EDF4] rounded-lg text-sm font-normal text-[#090406] placeholder:font-normal placeholder:text-sm placeholder:text-[#090406] pl-4 pr-14 outline-0"/>
                            {/* <img src="/images/search-box.svg" alt="icon" className="absolute top-1.5 right-1" /> */}
                        </div>
                    </div>
                </div>
            </div>
            <ShimmerTable className="pt-7" row={10} col={5} />
        </div>
    )
}
